import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAppState } from "@/context/AppState";
import { useI18n } from "@/context/I18nContext";
import { Loader2 } from "lucide-react";

export default function GenresPage() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const { filters, setFilters, setView } = useAppState();
  const { t } = useI18n();

  useEffect(() => {
    api.tags(120)
      .then((data) => setTags(data))
      .catch((err) => console.warn("[voix] tags fetch failed:", err))
      .finally(() => setLoading(false));
  }, []);

  const pickTag = (name) => {
    setFilters({ country: null, tag: name, language: null, mood: null, decade: null });
    setView("filter");
  };

  const grouped = React.useMemo(() => {
    const buckets = {};
    tags.forEach((t) => {
      const first = (t.name[0] || "#").toUpperCase();
      const key = /[A-Z]/.test(first) ? first : "#";
      (buckets[key] ||= []).push(t);
    });
    return Object.entries(buckets).sort(([a], [b]) => a.localeCompare(b));
  }, [tags]);

  return (
    <div className="p-6 md:p-8">
      <div>
        <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-pink-400">{t("landing.genres.pre").toUpperCase()}</div>
        <h1 className="font-heading font-black text-3xl md:text-5xl tracking-tight mt-1">{t("landing.genres.title")}<span className="text-pink-400">.</span></h1>
        <p className="font-body text-sm text-slate-500 mt-2 max-w-lg">
          {t("landing.genres.subtitle")}
        </p>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 mt-10 text-slate-500 font-mono-tech text-[10px] uppercase tracking-widest">
          <Loader2 className="animate-spin" size={14} /> {t("view.tuning").toUpperCase()}
        </div>
      ) : (
        <div data-testid="genres-list" className="mt-8 space-y-8">
          {grouped.map(([letter, items]) => (
            <div key={letter}>
              <div className="font-heading font-black text-2xl text-cyan-400 mb-3">{letter}</div>
              <div className="flex flex-wrap gap-2">
                {items.map((t) => (
                  <button
                    key={t.name}
                    data-testid={`genre-${t.name}`}
                    onClick={() => pickTag(t.name)}
                    className={`border px-3 py-1.5 text-xs font-mono-tech uppercase tracking-widest transition ${
                      filters.tag === t.name
                        ? "border-pink-500 text-pink-300 bg-pink-500/10"
                        : "border-[var(--voix-border)] text-slate-400 hover:border-pink-500/60 hover:text-pink-300"
                    }`}
                  >
                    <span>{t.name}</span>
                    <span className="text-slate-600 ml-2">{t.stationcount}</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
